import { SET_CLIENTSTATUS_LIST } from "./type";

const initialState = {
  list: "",
};

const clientList = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENTSTATUS_LIST:
      return {
        ...action.clientList,
      };
    default:
      return state;
  }
};

export default clientList;
